import { render, staticRenderFns } from "./DrawIndex.vue?vue&type=template&id=d52fe7de&scoped=true&"
import script from "./DrawIndex.vue?vue&type=script&lang=js&"
export * from "./DrawIndex.vue?vue&type=script&lang=js&"
import style0 from "./DrawIndex.vue?vue&type=style&index=0&id=d52fe7de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52fe7de",
  null
  
)

export default component.exports